import React, { useState, useEffect } from 'react';
import imageUrlBuilder from '@sanity/image-url';
import BlockContent from '@sanity/block-content-to-react';

import aboutMeImg from '../assets/about-me-img.jpg';
import sanityClient from '../client';

const builder = imageUrlBuilder(sanityClient);

function urlFor(source) {
  return builder.image(source);
}


export default function About() {
  const [author, setAuthor] = useState(null);

  useEffect(() => {
    sanityClient.fetch(`*[_type == "author"]{
      name,
      bio,
      "authorImage": image.asset->url
    }`).then((data) => setAuthor(data[0]))
    .catch(console.error)
  }, [])

  return (
    <main className="relative h-full" style={{minHeight: 'calc(100vh - 107px)'}}>
      <img src={aboutMeImg} alt="about me" className="absolute h-full w-full" />
      <div className="p-10 lg:pt-20 container mx-auto relative about">
        {author && (
          <section className="bg-green-800 bg-opacity-90 rounded-lg shadow-2xl lg:flex p-20">
            <img 
              src={urlFor(author.authorImage).url()} 
              className="rounded-full w-32 h-32 lg:w-64 lg:h-64 mr-8 mb-6" 
              alt={author.name}
            />
            <div className="text-lg flex flex-col justify-center">
              <h1 className="cursive text-6xl text-green-300 mb-4">
                Hey there. I'm{" "}
                <span className="text-green-100">{author.name}</span>
              </h1>
              <div className="prose lg:prose-xl text-white">
                <BlockContent blocks={author.bio} projectId="55qc9ajb" dataset="production" />
              </div>
            </div>
          </section>
        )}
        {!author && '加载中...'}
      </div>
    </main>
  ) 
}
